export function Header() {
  return (
    <h1 className="text-8xl sm:text-6xl md:text-[130px] font-bold mb-[-33px] sm:mb-[-20px] text-white relative z-10">
      <span>Say hi.</span>
    </h1>
  );
}
